import { BaseModal } from "components";

import LoadingLogo from "components/LoadingLogo";
import { ModalRedirectProps } from "./types";

export default function ModalRedirect({ text, isOpen }: ModalRedirectProps) {
	return (
		<BaseModal
			isOpen={isOpen}
			bodyClassName="justify-center items-center text-center"
		>
			<LoadingLogo />
			<h3 className="headline-3 text-neutral-low-pure-500 font-normal">
				{text}
			</h3>
		</BaseModal>
	);
}
